<template>
  <PageWrapper :title="title" ref="pageEl">
    <div class="container">
      <insurance-editor v-model="form" :logoUrl="logoUrl"></insurance-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import InsuranceEditor from "../components/InsuranceEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";

export default {
  components: {
    PageWrapper,
    ScButton,
    InsuranceEditor
  },
  data() {
    const title = "สร้างประกัน";
    const form = {
      label: "",
      description: "",
      url: "",
      logoFile: null
    };

    const logoUrl = null;
    return {
      title,
      form,
      logoUrl
    };
  },
  watch: {
    form(form, oldForm) {
      if (this.form.logoFile === oldForm.logoFile) {
        return;
      }

      this.logoUrl = URL.createObjectURL(this.form.logoFile);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {},
    setupData() {},
    async handleClickSave() {
      try {
        await this.createInsurance();
        this.$router.push({ name: "InsuranceListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async createInsurance() {
      const { label, description, url, logoFile } = this.form;
      const icon_url = await uploadPublicImage(logoFile);

      const params = {
        title: label,
        subtitle: description,
        web_url: url,
        icon_url
      };

      const response = await baanRueJaiClient.admin.insurances.post(params);

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/insurance/pages/InsuranceCreatePage.vue